<doc-language-button *ngFor="let language of supportedLanguages"
                     [documentTextContent]="this.documentTextContent"
                     [language]="language"
                     [selected]="this.selectedLanguage == language"
                     [title]=""
                     (confirmDeleteEvent)="delete(language)"
                     (languageNewEvent)="create(language)"
                     (changeToEvent)="changeTo(language)">
</doc-language-button>
